export const ALL_REGION_VALUE = '';
export const APAC_REGION_VALUE = 'Asia/Bangkok,Asia/Ho_Chi_Minh';

export const REGION_OPTIONS = [
  { text: 'All', value: ALL_REGION_VALUE },
  { text: 'APAC', value: APAC_REGION_VALUE },
];
